import { Box, Button } from '@achieve/ascend'
import { Typography } from 'components/Typography'

export const DatCtaButton = ({ copy = 'See your options', url = '/', onCtaClick }) => {
  return (
    <Box>
      <Button
        variant="contained"
        fullWidth={true}
        href={url}
        onClick={onCtaClick}
        data-testid="dat-cta-button"
      >
        <Typography variant="bodyLg" fontWeight="bold">
          {copy}
        </Typography>
      </Button>
    </Box>
  )
}
